const state = {
  enabled: false,
};

const getters = {
  get: state => state.enabled,
};
  
const mutations = {
  SET(state, data) {
    state.enabled = data;
  },
};
  
const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
